module.exports = __webpack_public_path__ + "static/media/jump-page-en.b1e25997.png";